/**
 * NESTY BLOOM — Mega Menu
 * Vanilla JS, sin librerías externas.
 *
 * Un único Mega Panel flotante (overlay) por categoría, apilados unos
 * sobre otros — solo el activo es visible. En móvil el panel se posiciona
 * con position:fixed (definido en CSS) y este script calcula el "top"
 * exacto midiendo en tiempo real dónde termina la barra de categorías,
 * en vez de asumir una altura fija de encabezado — así funciona sin
 * importar cuánto mida el header (con o sin barra de anuncios, etc).
 */
(function () {
  'use strict';

  function initMegaMenu(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.nb-megamenu__trigger'));
    var mobileQuery = window.matchMedia('(max-width: 560px)');

    function getPanel(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function positionPanelForMobile(panel) {
      if (!mobileQuery.matches) {
        panel.style.top = '';
        return;
      }
      var rect = root.getBoundingClientRect();
      panel.style.top = Math.round(rect.bottom) + 'px';
    }

    function closeAll() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        var panel = getPanel(trigger);
        if (panel) panel.classList.remove('is-active');
      });
    }

    function open(trigger) {
      closeAll();
      trigger.setAttribute('aria-expanded', 'true');
      var panel = getPanel(trigger);
      if (panel) {
        positionPanelForMobile(panel);
        panel.classList.add('is-active');
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeAll();
        } else {
          open(trigger);
        }
      });
    });

    // Cerrar al hacer clic fuera del menú
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    // Cerrar con Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Cerrar si el foco sale por completo del menú (navegación por teclado).
    // Solo cuando el navegador SÍ informa a dónde fue el foco (relatedTarget
    // no nulo): en touch (iOS Safari, Chrome Android) relatedTarget suele
    // venir null al tocar un botón, y tratarlo como "el foco salió del menú"
    // cerraba el panel en el mismo instante en que se abría (parpadeo).
    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !root.contains(e.relatedTarget)) closeAll();
    });

    // Recalcula la posición si cambia el tamaño de pantalla (rotación,
    // teclado virtual, etc.) mientras un panel está abierto.
    window.addEventListener('resize', function () {
      var activePanel = root.querySelector('.nb-megamenu__panel.is-active');
      if (activePanel) positionPanelForMobile(activePanel);
    });
  }

  function initAll(scope) {
    var context = scope || document;
    var menus = context.querySelectorAll('.nb-megamenu[data-nbmm-init="false"]');
    menus.forEach(function (root) {
      root.setAttribute('data-nbmm-init', 'true');
      initMegaMenu(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Reinicializa al agregar/editar la sección desde el editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
